import { createContext, useContext } from 'react'

import usePortalFirebaseAuth from '@apps-common/hooks/useFirebaseAuth'
import { IAuthActionResponse } from '@apps-common/types/auth'
import { AuthenticatedUser } from '@apps-common/types/portal'

type IAuthContext = {
  initialized: boolean
  user: AuthenticatedUser | null
  logIn: (email: string, password: string, persist: boolean) => Promise<AuthenticatedUser | string>
  logOut: () => void
  forgotPassword: (email: string) => Promise<IAuthActionResponse>
  forgotPasswordByUsername: (username: string) => Promise<IAuthActionResponse>
  resetPassword: (email: string, code: string, newPassword: string) => Promise<IAuthActionResponse>
  verifyCode: (code: string) => Promise<IAuthActionResponse>
  reloadUser: () => Promise<void>
  updateProfileImage: (newPhotoUrl: string) => void
}

const AuthContext = createContext<IAuthContext>({
  initialized: false,
  user: null,
  logIn: async () => 'Not initialized',
  logOut: () => {},
  forgotPassword: async () => ({ result: false, message: 'Not initialized' }),
  forgotPasswordByUsername: async () => ({ result: false, message: 'Not initialized' }),
  resetPassword: async () => ({ result: false, message: 'Not initialized' }),
  verifyCode: async () => ({ result: false, message: 'Not initialized' }),
  reloadUser: async () => {},
  updateProfileImage: () => {}
})

export const PortalAuthProvider = ({ children }: any) => {
  const auth = usePortalFirebaseAuth()

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}

export const useAuth = () => useContext(AuthContext)
